
const CARD_SELECTOR = '.js-card';
const FOCUS_CLASS = 'on-focus';
const UMBRACO_CHECKBOX_SELECTOR = '.umbraco-forms-field.checkbox';
const BROCHURE_STICKY_SELECTOR = '.brochure-sticky';
const FOOTER_SELECTOR = '.footer-tertiary';
const FOOTER_MARGIN = '72px';

const onCardFocusIn = (e: FocusEvent): void => {
  const card = (e.target as HTMLElement | null)?.closest?.(CARD_SELECTOR);
  if (card) {
    card.classList.add(FOCUS_CLASS);
  }
};

const onCardFocusOut = (e: FocusEvent): void => {
  const card = (e.target as HTMLElement | null)?.closest?.(CARD_SELECTOR);
  if (!card) {
    return;
  }
  const next = e.relatedTarget as Node | null;
  if (next && card.contains(next)) {
    return;
  }
  card.classList.remove(FOCUS_CLASS);
};

const setupCardFocusStates = (): void => {
  document.addEventListener('focusin', onCardFocusIn);
  document.addEventListener('focusout', onCardFocusOut);
};

const fixUmbracoCheckboxStyling = (): void => {
  const checkboxFields = document.querySelectorAll<HTMLElement>(UMBRACO_CHECKBOX_SELECTOR);
  
  checkboxFields.forEach((field) => {
    const label = field.querySelector<HTMLLabelElement>('label');
    const input = field.querySelector<HTMLInputElement>('input');
    
    if (label && input && input.parentNode) {
      input.parentNode.insertBefore(label, input.nextSibling);
    }
  });
};

const adjustFooterMarginForStickyBar = (): void => {
  const footer = document.querySelector<HTMLElement>(FOOTER_SELECTOR);
  if (!footer) {
    console.warn(`Footer element not found with selector: ${FOOTER_SELECTOR}`);
    return;
  }

  const updateFooterMargin = (): void => {
    const stickyBar = document.querySelector(BROCHURE_STICKY_SELECTOR);
    footer.style.marginBottom = stickyBar ? FOOTER_MARGIN : '';
  };

  // Use MutationObserver to watch for dynamically added/removed brochure-sticky elements
  const observer = new MutationObserver(updateFooterMargin);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Check initial state
  updateFooterMargin();
};

const init = (): void => {
  setupCardFocusStates();
  fixUmbracoCheckboxStyling();
  adjustFooterMarginForStickyBar();
};

export { init };

